import $ from './components/utils/NodeList.js'
import dropdown from './components/Dropdown.vue'
import input from './components/Input.vue'
import select from './components/Select.vue'
import tab from './components/Tab.vue'
import tabGroup from './components/TabGroup.vue'
import tabs from './components/Tabs.vue'

// Need to be inspected and/or fixed
import accordion from './Accordion.vue'
import affix from './Affix.vue'
import alert from './Alert.vue'
import aside from './Aside.vue'
import buttonGroup from './buttonGroup.vue'
import carousel from './Carousel.vue'
import checkbox from './Checkbox.vue'
import datepicker from './Datepicker.vue'
import formGroup from './FormGroup.vue'
import formValidator from './components/FormValidator.vue'
import modal from './Modal.vue'
import navbar from './Navbar.vue'
import option from './Option.vue'
import panel from './Panel.vue'
import popover from './Popover.vue'
import progressbar from './Progressbar.vue'
import radio from './Radio.vue'
import slider from './Slider.vue'
import spinner from './Spinner.vue'
import tooltip from './Tooltip.vue'
import typeahead from './Typeahead.vue'

const components = {
  // $,
  dropdown,
  formValidator,
  input,
  select,
  tab,
  tabGroup,
  tabs,
  // Pending
  accordion,
  affix,
  alert,
  aside,
  buttonGroup,
  carousel,
  checkbox,
  datepicker,
  formGroup,
  modal,
  navbar,
  option,
  panel,
  popover,
  progressbar,
  radio,
  slider,
  spinner,
  tooltip,
  typeahead,
}

const VueStrap = Object.assign({}, components, {
  install: (Vue) => {
    Object.keys(components).forEach((key) => {
      const componentName = 'vb' + key[0].toUpperCase() + key.substring(1)
      // console.log(" => registering a VueStrap component:", componentName);
      Vue.component(componentName, components[key])
    })
  },
})

export default VueStrap
